import { render, staticRenderFns } from "./CommunicationTypeItem.vue?vue&type=template&id=0565013e&scoped=true"
import script from "./CommunicationTypeItem.vue?vue&type=script&lang=js"
export * from "./CommunicationTypeItem.vue?vue&type=script&lang=js"
import style0 from "./CommunicationTypeItem.vue?vue&type=style&index=0&id=0565013e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0565013e",
  null
  
)

export default component.exports